import { useMemo } from 'react';
import { Flex, Image, Paragraph } from 'theme-ui';
import { useSettings } from '@backpackjs/storefront';

import { themed } from './Icons.theme';

export const Icons = themed(({ theme, product }) => {
  const settings = useSettings();
  const iconsData = settings?.product?.icons?.list;
  const iconsDataDep = iconsData?.length
    ? iconsData?.map((v) => v.tag + v.label + v.icon?.src).join('')
    : null;

  const icons = useMemo(() => {
    if (!product?.tags?.length) return [];
    return product.tags.reduce((arr, tag) => {
      if (!tag.startsWith('icon::')) return arr;
      const tagValue = tag.split('icon::')[1]?.toLowerCase().trim();
      return tagValue ? [...arr, tagValue] : arr;
    }, []);
  }, [product?.id]);

  const iconsDep = icons.join('');

  const iconsMap = useMemo(() => {
    if (!icons.length || !iconsData?.length) return {};
    return iconsData.reduce((obj, icon, index) => {
      const tag = icon.tag.toLowerCase().trim();
      obj[tag] = {
        ...icon,
        tag,
        order: index,
      };
      return obj;
    }, {});
  }, [iconsDataDep, iconsDep]);

  const iconsMapDep = Object.values(iconsMap)
    .map((v) => v.tag)
    .join('');

  const sortedIcons = useMemo(() => {
    if (!icons.length || !iconsMapDep) return [];
    return [...icons].sort((a, b) => {
      if (iconsMap[a]?.order < iconsMap[b]?.order) return -1;
      if (iconsMap[a]?.order > iconsMap[b]?.order) return 1;
      return 0;
    });
  }, [iconsDep, iconsMapDep]);

  return sortedIcons.length ? (
    <Flex data-comp={Icons.displayName} sx={theme.wrapper}>
      {sortedIcons.map((item) => {
        const icon = iconsMap[item];
        return icon ? (
          <Flex key={icon.tag} sx={theme.iconsRow}>
            <Image
              alt={icon.tag}
              src={icon.icon?.src || '/svgs/default-image.svg'}
              sx={theme.icon}
              loading="lazy"
            />
            <Paragraph sx={theme.label}>{icon.label}</Paragraph>
          </Flex>
        ) : null;
      })}
    </Flex>
  ) : null;
});

Icons.displayName = 'Icons';
